import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from './config';
import { useAuth } from './context/AuthContext';

function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (data.data?.access_token || data.access_token) {
        const token = data.data?.access_token || data.access_token;
        const userData = data.data?.user || data.user || {};
        login(token, userData);

        if (userData.role === 'partner') {
          navigate('/partner/dashboard');
        } else {
          navigate('/dashboard');
        }
      } else {
        setError(data.error?.message || data.message || 'Login Failed');
      }
    } catch (err) {
      console.error(err);
      setError('Network Error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', background: '#f5f7fa' }}>
      <div style={{ width: '100%', maxWidth: '420px', padding: '0 1rem' }}>
        <div className="text-center mb-4">
          <h3 className="fw-bold" style={{ color: '#31374a', letterSpacing: '0.04em' }}>NekotoWan</h3>
          <p style={{ color: '#8a94ad', fontSize: '0.8125rem' }}>Admin Login</p>
        </div>
        <div className="card login-card">
          <div className="card-body p-4">
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label" style={{ fontSize: '0.8125rem', fontWeight: 600 }}>
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="admin@cranova.jp"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                  style={{ fontSize: '0.8125rem' }}
                />
              </div>
              <div className="mb-4">
                <label htmlFor="password" className="form-label" style={{ fontSize: '0.8125rem', fontWeight: 600 }}>
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{ fontSize: '0.8125rem' }}
                />
              </div>
              <button
                type="submit"
                className="btn btn-phoenix-primary w-100"
                disabled={loading || !email || !password}
              >
                {loading ? 'Login...' : 'Login'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
